import classNames from 'classnames';
import type { ButtonHTMLAttributes, FC } from 'react';

/** @deprecated */
export const TextButton: FC<ButtonHTMLAttributes<HTMLButtonElement>> = (
  props,
) => {
  // props
  const { className, children, ...attrs } = props;
  return (
    <button
      type="button"
      {...attrs}
      className={classNames(
        'flex justify-center items-center p-1 rounded text-xs text-main transition enabled:hover:bg-selected enabled:active:bg-active disabled:text-secondary-3 disabled:cursor-not-allowed',
        className,
      )}
    >
      {children}
    </button>
  );
};
